module.exports = __webpack_public_path__ + "img/guanyu_songda@2x.e7b72d36.png";